import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import moment from "moment";
import React, { useState } from "react";
import { withDataProvider } from "react-admin";

const styles = {
  action: {
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  },
  size: {
    maxWidth: 500,
  },
};

const CANCELLABLE_STATUSES = [
  "ticketed",
  "pending_confirmation",
  "pending_ticketing",
];

function CancelTicketsButton(props) {
  const [isOpen, setOpen] = useState(false);
  const {
    dataProvider,
    selectedIds,
    selectedTickets = [],
    resource,
    label,
  } = props;

  const isCancellable =
    selectedTickets.length === 0 ||
    selectedTickets.every((tk) => CANCELLABLE_STATUSES.includes(tk.status));

  const handleDialogClose = () => setOpen(false);

  const handleConfirm = () => {
    dataProvider(
      "CANCEL_TICKET",
      "",
      { ticket_ids: selectedIds },
      {
        onSuccess: {
          notification: { body: "Annulations éffectuées", level: "info" },
          refresh: true,
          redirectTo: `/${resource}`,
          unselectAll: true,
        },
        onError: {
          notification: {
            body: "Erreur lors de l'annulation",
            level: "warning",
          },
          refresh: true,
          unselectAll: true,
        },
      }
    );
    setOpen(false);
  };

  if (!isCancellable) {
    return null;
  }

  return (
    <>
      <Button variant="outlined" color="primary" onClick={() => setOpen(true)}>
        {label}
      </Button>
      <Dialog
        open={isOpen}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={styles.action}>
          ANNULATION DE {selectedIds.length} PRESTATIONS
        </DialogTitle>
        <DialogContent style={styles.size}>
          <DialogContentText id="alert-dialog-description">
            <div>
              <p>
                Attention: nous tenterons d'effectuer l'annulation de ces
                prestations automatiquement. Dans certains cas, cela peut ne pas
                être possible. Votre agence traitera alors la ou les demande(s)
                d'annulation manuellement, pendant leurs heures d'ouverture.
              </p>
              {selectedTickets.map((tk) => (
                <p style={{ fontWeight: "bold" }} key={tk.id}>
                  {tk.ticket_travelers != null &&
                    tk.ticket_travelers.length > 0 && (
                    <>
                        Pax: {tk.ticket_travelers[0].firstname}{" "}
                      {tk.ticket_travelers[0].lastname}
                      <br />
                    </>
                  )}
                  Prestation:
                  <br />-{tk.type} {tk.to} - {tk.from}{" "}
                  {moment.utc(tk.departure).format("DD/MM/YYYY à HH:mm")}{" "}
                  {tk.offer != null ? tk.offer.fare_category : null}
                  <br />
                </p>
              ))}
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogContent style={styles.action}>
          <Button
            onClick={handleDialogClose}
            variant="outlined"
            color="secondary"
          >
            Annuler
          </Button>
          <Button
            onClick={handleConfirm}
            variant="contained"
            color="secondary"
            autoFocus
          >
            Confirmer
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default withDataProvider(CancelTicketsButton);
